module.exports = __webpack_public_path__ + "img/metadata_inactive.f113c543.svg";